/**
 * Throws when mandatory bone could not find
 */
export class BoneNotFoundError extends Error {
    constructor(boneName) {
        super(`Bone:${boneName} NotFound`);
        this.boneName = boneName;
        this.name = 'BoneNotFoundError';
    }
}
//# sourceMappingURL=errors.js.map